<template>
  <v-app id="inspire" class="app-background">
      <router-view />
  </v-app>
</template>

<script>
// import { mapActions } from "vuex";
export default {
  data() {
    return {
      isTabClosed: false,

      logoutTimer: null, // Timer for automatic logout
      inactivityDuration: 10 * 60 * 1000, // 10 minutes in milliseconds
    };
  },
  created() {
    if (this.roleName == 'Super Admin') {
      this.$router.push('/settings');
    }
  },
  methods: {
    logout() {
      this.logOut();
      location.replace("/");
    },
  },
};
</script>

<style>
#inspire{
  background-image: url('../src/assets/background.jpg');
  background-size: cover; 
  background-position: center;
}
.vs-input-content input {
  padding-top: 13px !important;
  padding-bottom: 13px !important;
}

.search-field-input .vs-input-content input {
  padding-top: 6px !important;
  padding-bottom: 6px !important;
}

.vs-sidebar__item.active {
  color: #6c5dd4 !important;
}

.vs-sidebar__item:after {
  background: #6c5dd4 !important;
}

.vs-input {
  background: #f1f2f6;
}

.v-overlay {
  z-index: 0 !important;
}
.unitCreateDialog .v-stepper__header {
  box-shadow: none !important;
}
.v-dialog {
  box-shadow: none !important;
}
.vs-dialog {
  font-family: 'roboto' !important;

}
.v-dialog {
  box-shadow: none !important;
}

</style>
